import { createAction } from '@reduxjs/toolkit';
import { type Facility } from '@reliance/types/models/Facility';
import resources from '../../resources';

export const baseDataLoadSuccess = createAction<Facility>(
  'WEBSITE/BASE_DATA_LOAD_SUCCESS',
);
export function loadBaseData() {
  return (dispatch) => {
    return resources.website
      .getBaseData(import.meta.env.VITE_HOSTNAME ?? location.hostname)
      .then((result: Facility) => {
        dispatch(baseDataLoadSuccess(result));
        return result;
      })
      .catch((err) => {
        throw err;
      });
  };
}
